import { Box } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import Navigation from './components/layout/Navigation';
import TechDoodles from './components/layout/TechDoodles';
import AboutSection from './components/sections/AboutSection';
import ExperienceSection from './components/sections/ExperienceSection';
import Footer from './components/sections/Footer';
import HeroSection from './components/sections/HeroSection';
import ProjectsSection from './components/sections/ProjectsSection';
import SkillsSection from './components/sections/SkillsSection';
import TestimonialsSection from './components/sections/TestimonialsSection';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00ADB5',
      light: '#33BDC4',
      dark: '#007A80',
    },
    secondary: {
      main: '#EEEEEE',
      light: '#F5F5F5',
      dark: '#BDBDBD',
    },
    background: {
      default: '#222831',
      paper: '#393E46',
    },
    text: {
      primary: '#EEEEEE',
      secondary: '#9E9E9E',
    },
    success: {
      main: '#4CAF50',
    },
    error: {
      main: '#F44336',
    },
    warning: {
      main: '#FF9800',
    },
    info: {
      main: '#2196F3',
    },
  },
  typography: {
    fontFamily: 'Inter, Gilroy, Arial, sans-serif',
    h1: {
      fontFamily: 'Gilroy, sans-serif',
      fontWeight: 800,
    },
    h2: {
      fontFamily: 'Gilroy, sans-serif',
      fontWeight: 700,
    },
    h3: {
      fontFamily: 'Gilroy, sans-serif',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 12,
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
  },
});

const Home: React.FC = () => {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Box sx={{ 
        minHeight: '100vh', 
        background: 'linear-gradient(135deg, #222831 0%, #393E46 100%)',
        position: 'relative',
      }}>
        <TechDoodles />
        <Navigation />
        <HeroSection />
        <AboutSection />
        <SkillsSection />
        <ExperienceSection />
        <ProjectsSection />
        <TestimonialsSection />
        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default Home;
